import React from "react";
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image";

import { Divider, Stack, styled, Typography, Grid, Container, ImageList, ImageListItem, ImageListItemBar, Paper } from '@mui/material';
import ContentWithImage from "./ContentWithImage";

const Root = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingLeft: 20,
  paddingRight: 20,
});


const ImgItem = styled(Img)(({ theme }) => ({
  maxWidth: 350,

  [ theme.breakpoints.down('sm') ]: {
    width: '100%',
  },
  [ theme.breakpoints.up('md') ]: {
    height: '100%',
  }
}));

const Item = styled('div')({
  display: "flex",
  flexDirection: "column",
  width: '100%',
  height: '100',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: 240,
})

const Spacer = styled('div')({
  flex: 1,
})

const AccessoryNames: {[key: string] : string} = {
  "zajigalka": "Lighter (aka Zajigalka)",
  "water": "Water Bottle (aka Butulka)",
  "vosku_cep": "Gold Chain (aka Vosku tsep)",
  "watch": "Gold Watch (aka Voskuc zham)",
  "tzbex_3": "Beads (aka Tzbex)",
  "shemushka": "Sunflower Seeds (aka Shemushka)",
  "plan": "Joint (aka Plan)",
  "matchstick": "Matchstick (aka Lucku chop)",
  "matniq": "Gold Ring (aka Matniq)",
  "card_blot": "Playing Cards (aka Bloti card)",
  "mag": "Stereo (aka Mag)",
  "limonad": "Soda (aka Limonad)",
  "kepka": "A Cap (aka Kepka)",
  "golden_teeth": "Goldem Tooth (aka Vosku atam)",
  "cigaret": "Cigarette (aka Papiroz)",
  "balniq": "Key (aka Balniq)",
  "cap": "A Cap (aka Kepka)",
  "aparat": "Camera (aka Aparat)",
  "bread": "Bread (aka Matnaqash)",
  "aknots": "Sunglasses (aka Aknots)",
  "nardi": "Backgammon (aka Nardi)" 
}




const Features: React.FC = () => {
  const images = useStaticQuery(graphql`
    query {
      accessories: allFile(filter: {relativeDirectory: {in: "accessories"}}) {
        edges {
          node {
            publicURL
            name
            childImageSharp {
              fluid(maxWidth: 600, webpQuality: 90) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
      }
    }
  `);


const getTitle = (name: string) => {
  return AccessoryNames[name] ? AccessoryNames[name] : name;
}


  // console.log(images.accessories.edges[1].node);

  return (
    <Root>
      <Typography variant="button" align="center" paragraph id="accessory-list">
        Some of the accessories that Hayape's could have
      </Typography>


      <Container maxWidth="md">
        <Paper>
          <ImageList>
            {images.accessories.edges.map((item: any) => (
              <ImageListItem key={item.node.publicURL}>
                <ImgItem fluid={item.node.childImageSharp.fluid} />
                <ImageListItemBar
                  title={getTitle(item.node.name as string)}
                />
              </ImageListItem>
            ))}
          </ImageList>
        </Paper>
      </Container>

    </Root>
  );
};

export default Features;